/*!
 * WellVita AI Chat Widget v5.0
 * Refonte desktop (charte DM Sans/Playfair, fenetre 420x780, animations) + product cards + stock temps reel
 */
(function () {
  'use strict';

  const CONFIG = window.WV_CHAT || {};
  const WEBHOOK_URL = CONFIG.webhook || '';
  const WEBHOOK_SECRET = CONFIG.secret || 'wv-df024b9ec1f64fc8208b197b26131500';
  const WHATSAPP_URL = CONFIG.whatsapp || 'https://wa.me/2250700106710?text=Bonjour%20WellVita%2C%20je%20souhaite%20des%20conseils%20sur%20vos%20compl%C3%A9ments%20alimentaires';
  const BRAND_COLOR = '#3e5687';
  const BRAND_LIGHT = '#eef1f8';
  const MAX_STORED_MSGS = 15;
  const INACTIVITY_MS = 30 * 60 * 1000;
  const SESSION_TTL_MS = 30 * 60 * 1000;
  const IS_MOBILE = function() { return window.innerWidth <= 480; };

  // Session management — try/catch for Safari private mode (localStorage blocked)
  var _inMemSessionId = null;
  function getSessionId() {
    try {
      var id = localStorage.getItem('wv_session_id');
      if (!id) {
        id = 'wv_' + Math.random().toString(36).substring(2, 11) + '_' + Date.now();
        localStorage.setItem('wv_session_id', id);
      }
      return id;
    } catch(e) {
      if (!_inMemSessionId) {
        _inMemSessionId = 'wv_' + Math.random().toString(36).substring(2, 11) + '_' + Date.now();
      }
      return _inMemSessionId;
    }
  }

  let sessionId = getSessionId();
  let MSG_STORE_KEY = 'wv_msgs_' + sessionId;

  // HTML escape — prevents XSS when injecting user data into innerHTML
  function escapeHtml(str) {
    return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  }

  // fetch wrapper with 30s timeout + shared secret header
  function wvFetch(url, opts) {
    var ctrl = new AbortController();
    var timer = setTimeout(function() { ctrl.abort(); }, 30000);
    var headers = Object.assign({ 'X-WV-Secret': WEBHOOK_SECRET }, opts.headers || {});
    return fetch(url, Object.assign({}, opts, { headers: headers, signal: ctrl.signal }))
      .finally(function() { clearTimeout(timer); });
  }

  // Markdown renderer — bold + links + newlines
  function renderMarkdown(text) {
    return text
      .replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener" style="color:#3e5687;text-decoration:underline;">$1</a>')
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\n/g, '<br>');
  }

  // Message persistence
  function saveMessages() {
    try {
      const items = [];
      Array.from(messagesEl.children).forEach(function(el) {
        if (el.classList.contains('typing')) return;
        if (el.classList.contains('wv-msg')) {
          items.push({ c: el.classList.contains('user') ? 'u' : 'b', h: el.innerHTML });
        } else if (el.classList.contains('wv-whatsapp-cta')) {
          items.push({ c: 'wa' });
        } else if (el.classList.contains('wv-checkout-btn')) {
          items.push({ c: 'co', u: el.href });
        } else if (el.classList.contains('wv-product-cards')) {
          try {
            var cardsData = el.dataset.wvCards ? JSON.parse(el.dataset.wvCards) : null;
            if (cardsData) items.push({ c: 'pc', cards: cardsData });
          } catch(e) {}
        }
      });
      localStorage.setItem(MSG_STORE_KEY, JSON.stringify(items.slice(-MAX_STORED_MSGS)));
      localStorage.setItem('wv_last_ts', String(Date.now()));
    } catch (e) {}
  }

  function makeWaBtn() {
    var btn = document.createElement('button');
    btn.className = 'wv-whatsapp-cta';
    btn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.114.554 4.1 1.525 5.823L.057 23.5l5.808-1.524A11.953 11.953 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.907 0-3.697-.5-5.25-1.377l-.375-.223-3.447.903.923-3.369-.245-.389A9.96 9.96 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/></svg> Parler à notre équipe';
    btn.addEventListener('click', function () { window.open(WHATSAPP_URL, '_blank'); });
    return btn;
  }

  function makeChips(labels) {
    var wrap = document.createElement('div');
    wrap.className = 'wv-chips';
    labels.forEach(function (label) {
      var chip = document.createElement('button');
      chip.className = 'wv-chip';
      chip.type = 'button';
      chip.textContent = label;
      chip.addEventListener('click', function () {
        wrap.remove();
        sendMessage(label);
      });
      wrap.appendChild(chip);
    });
    return wrap;
  }

  function removeChips() {
    messagesEl.querySelectorAll('.wv-chips').forEach(function (el) { el.remove(); });
  }

  function makeCheckoutBtn(url) {
    var a = document.createElement('a');
    a.className = 'wv-checkout-btn';
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = '💳 Finaliser et payer ma commande →';
    return a;
  }

  function restoreMessages() {
    try {
      // Expire session si dernière activité > 30 min
      var lastTs = parseInt(localStorage.getItem('wv_last_ts') || '0', 10);
      if (lastTs && (Date.now() - lastTs) > SESSION_TTL_MS) {
        try {
          localStorage.removeItem(MSG_STORE_KEY);
          localStorage.removeItem('wv_last_ts');
          localStorage.removeItem('wv_session_id');
        } catch(e) {}
        sessionId = getSessionId();
        MSG_STORE_KEY = 'wv_msgs_' + sessionId;
        return false;
      }
      const saved = localStorage.getItem(MSG_STORE_KEY);
      if (!saved) return false;
      const msgs = JSON.parse(saved);
      if (!msgs.length) return false;
      msgs.forEach(function (msg) {
        if (msg.c === 'wa') {
          messagesEl.appendChild(makeWaBtn());
        } else if (msg.c === 'co' && msg.u) {
          messagesEl.appendChild(makeCheckoutBtn(msg.u));
        } else if (msg.c === 'pc') {
          if (msg.cards && msg.cards.length) renderProductCards(msg.cards);
        } else {
          const el = document.createElement('div');
          el.className = 'wv-msg ' + (msg.c === 'u' ? 'user' : 'bot');
          el.innerHTML = msg.h;
          messagesEl.appendChild(el);
        }
      });
      scrollToBottom();
      return true;
    } catch (e) {
      return false;
    }
  }

  // CSS injection
  const style = document.createElement('style');
  style.textContent = `
    #wv-bubble-ripple {
      position: fixed !important;
      bottom: 20px !important;
      right: 20px !important;
      width: 84px !important;
      height: 84px !important;
      border-radius: 50%;
      pointer-events: none;
      z-index: 2147483645 !important;
    }
    #wv-bubble-ripple::before,
    #wv-bubble-ripple::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 50%;
      background: rgba(62,86,135,0.38);
      animation: wv-ripple 2.4s ease-out infinite;
    }
    #wv-bubble-ripple::after { animation-delay: 1.2s; }
    #wv-bubble-ripple.wv-hidden { display: none !important; }
    @keyframes wv-ripple {
      0%   { transform: scale(1);   opacity: 0.55; }
      100% { transform: scale(2.1); opacity: 0; }
    }
    #wv-chat-bubble {
      position: fixed !important;
      bottom: 20px !important;
      right: 20px !important;
      width: 84px !important;
      height: 84px !important;
      border-radius: 50% !important;
      background: transparent !important;
      cursor: pointer;
      z-index: 2147483647 !important;
      display: flex !important;
      align-items: center;
      justify-content: center;
      overflow: hidden !important;
      box-shadow: 0 6px 24px rgba(62,86,135,0.4) !important;
      filter: none !important;
    }
    #wv-chat-bubble.wv-hidden { opacity: 0 !important; pointer-events: none !important; display: none !important; }
    #wv-chat-bubble.wv-open { box-shadow: 0 3px 12px rgba(62,86,135,0.25) !important; }
    #wv-chat-bubble img.wv-bubble-logo {
      width: 84px; height: 84px; object-fit: cover;
      border-radius: 50%; background: #fff;
    }
    .wv-bubble-emoji {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center 15%;
    }
    #wv-chat-bubble .wv-hidden { display: none !important; }
    #wv-chat-notif {
      position: fixed; bottom: 112px; right: 24px;
      background: #fff;
      border: 1px solid #e3e8f2;
      border-radius: 16px;
      padding: 18px 40px 16px 20px;
      box-shadow: 0 2px 6px rgba(50,50,83,0.06), 0 12px 36px rgba(50,50,83,0.16);
      max-width: 258px; z-index: 9997; cursor: pointer;
      font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      transform-origin: bottom right;
      animation: wv-notif-in 220ms cubic-bezier(0.23, 1, 0.32, 1);
      transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms cubic-bezier(0.23, 1, 0.32, 1);
    }
    @media (hover: hover) and (pointer: fine) {
      #wv-chat-notif:hover {
        border-color: ${BRAND_COLOR};
        box-shadow: 0 4px 10px rgba(50,50,83,0.08), 0 14px 38px rgba(50,50,83,0.18);
        transform: translateY(-1px);
      }
    }
    #wv-chat-notif.wv-hidden { display: none; }
    #wv-chat-notif .wv-notif-title {
      margin: 0;
      font-family: 'Playfair Display', Georgia, serif; font-style: italic;
      font-size: 17px; font-weight: 600; color: #323253; line-height: 1.3;
    }
    #wv-chat-notif .wv-notif-sub {
      font-size: 12.5px; font-weight: 400; color: #5a5a72; margin-top: 6px; line-height: 1.5;
    }
    #wv-chat-notif .wv-notif-cta {
      display: inline-flex; align-items: center; gap: 5px;
      font-size: 13px; font-weight: 600; color: ${BRAND_COLOR}; margin-top: 10px;
      border-bottom: 1px solid transparent; transition: border-color 150ms ease;
    }
    #wv-chat-notif:hover .wv-notif-cta { border-bottom-color: ${BRAND_COLOR}; }
    #wv-chat-notif .wv-notif-close {
      position: absolute; top: 8px; right: 8px;
      width: 22px; height: 22px; border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      font-size: 11px; color: #9aa1b5; cursor: pointer; line-height: 1;
      transition: background 150ms ease, color 150ms ease;
    }
    #wv-chat-notif .wv-notif-close:hover { background: #eef1f8; color: #5a5a72; }
    @media (max-width: 480px) {
      /* Notification compacte sur smartphone */
      #wv-chat-notif { bottom: 112px; right: 14px; max-width: 188px; padding: 12px 32px 11px 14px; }
      #wv-chat-notif .wv-notif-title { font-size: 14.5px; }
      #wv-chat-notif .wv-notif-sub { font-size: 11.5px; margin-top: 4px; }
      #wv-chat-notif .wv-notif-cta { font-size: 12px; margin-top: 7px; }
      #wv-chat-bubble { bottom: 16px !important; right: 16px !important; }
      /* Onde alignée sur la bulle en mobile (fix désalignement) */
      #wv-bubble-ripple { bottom: 16px !important; right: 16px !important; }
    }
    @keyframes wv-notif-in {
      from { opacity: 0; transform: translateY(8px) scale(0.97); }
      to   { opacity: 1; transform: translateY(0) scale(1); }
    }
    @media (prefers-reduced-motion: reduce) {
      #wv-chat-notif { animation: wv-notif-fade 200ms ease; }
    }
    @keyframes wv-notif-fade { from { opacity: 0; } to { opacity: 1; } }
    @keyframes wv-pulse {
      0%, 100% { opacity: 1; transform: scale(1); }
      50% { opacity: 0.5; transform: scale(1.3); }
    }
    #wv-chat-bubble .wv-badge {
      position: absolute;
      top: -4px;
      right: -4px;
      width: 18px;
      height: 18px;
      background: #e53935;
      border-radius: 50%;
      font-size: 11px;
      color: #fff;
      font-weight: 700;
      display: none;
      align-items: center;
      justify-content: center;
    }

    #wv-chat-window {
      position: fixed !important;
      bottom: 28px;
      right: 28px;
      width: 420px;
      max-width: calc(100vw - 32px);
      height: min(780px, calc(100vh - 96px));
      max-height: calc(100vh - 56px);
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 4px 16px rgba(50,50,83,0.10), 0 24px 64px rgba(50,50,83,0.22);
      z-index: 2147483646 !important;
      display: none;
      flex-direction: column;
      overflow: hidden;
      font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      -webkit-overflow-scrolling: touch;
    }
    #wv-chat-window.open { display: flex; }
    /* Ouverture/fermeture animées — desktop uniquement (mobile = plein écran, comportement intouché) */
    @media (min-width: 481px) {
      #wv-chat-window { transform-origin: 100% 100%; }
      #wv-chat-window.open { animation: wv-win-in 260ms cubic-bezier(0.23, 1, 0.32, 1); }
      #wv-chat-window.wv-closing { display: flex; animation: wv-win-out 200ms cubic-bezier(0.23, 1, 0.32, 1) forwards; pointer-events: none; }
    }
    @keyframes wv-win-in {
      from { opacity: 0; transform: scale(0.95) translateY(12px); }
      to   { opacity: 1; transform: scale(1) translateY(0); }
    }
    @keyframes wv-win-out {
      from { opacity: 1; transform: scale(1) translateY(0); }
      to   { opacity: 0; transform: scale(0.95) translateY(12px); }
    }
    @media (prefers-reduced-motion: reduce) {
      #wv-chat-window.open { animation: none; }
      #wv-chat-window.wv-closing { animation: wv-win-fade-out 200ms ease forwards; }
      .wv-msg { animation: none !important; }
    }
    @keyframes wv-win-fade-out { from { opacity: 1; } to { opacity: 0; } }

    .wv-header {
      background: linear-gradient(160deg, #323253 0%, ${BRAND_COLOR} 100%);
      color: #fff;
      padding: 16px 18px 14px;
      display: flex;
      align-items: center;
      gap: 12px;
      flex-shrink: 0;
    }
    .wv-header-avatar {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      overflow: hidden;
      box-shadow: 0 0 0 2px rgba(255,255,255,0.25);
    }
    .wv-header-avatar video { width: 100%; height: 100%; object-fit: cover; display: block; }
    .wv-header-info { flex: 1; min-width: 0; }
    .wv-header-name {
      font-family: 'Playfair Display', Georgia, serif;
      font-style: italic;
      font-weight: 600;
      font-size: 19px;
      letter-spacing: 0.01em;
    }
    .wv-header-sub { font-size: 12px; opacity: 0.78; margin-top: 1px; }
    .wv-header-status { display: flex; align-items: center; gap: 5px; font-size: 11.5px; margin-top: 3px; opacity: 0.92; }
    .wv-header-dot {
      width: 7px; height: 7px; border-radius: 50%; background: #22c55e;
      box-shadow: 0 0 6px rgba(34,197,94,0.8); flex-shrink: 0;
    }
    .wv-close-btn {
      cursor: pointer;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: rgba(255,255,255,0.12);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      line-height: 1;
      flex-shrink: 0;
      transition: background 150ms ease;
    }
    .wv-close-btn:hover { background: rgba(255,255,255,0.24); }

    .wv-messages {
      flex: 1;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain;
      touch-action: pan-y;
      padding: 20px 18px 8px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      background: linear-gradient(180deg, #f4f7ff 0%, #ffffff 140px);
    }
    .wv-msg {
      max-width: 78%;
      padding: 12px 15px;
      border-radius: 16px;
      font-size: 14.5px;
      line-height: 1.55;
      word-break: break-word;
      animation: wv-msg-in 220ms cubic-bezier(0.23, 1, 0.32, 1);
    }
    @keyframes wv-msg-in {
      from { opacity: 0; transform: translateY(8px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .wv-msg.bot {
      background: #fff;
      color: #1a1a2e;
      align-self: flex-start;
      border: 1px solid #e3e8f2;
      border-bottom-left-radius: 5px;
      box-shadow: 0 1px 3px rgba(50,50,83,0.05);
    }
    .wv-msg.user {
      background: ${BRAND_COLOR};
      color: #fff;
      align-self: flex-end;
      border-bottom-right-radius: 5px;
    }
    .wv-msg.typing {
      background: #fff;
      border: 1px solid #e3e8f2;
      align-self: flex-start;
      padding: 14px 16px;
      border-bottom-left-radius: 5px;
    }
    .wv-typing-dots {
      display: flex;
      gap: 4px;
      align-items: center;
    }
    .wv-typing-dots span {
      width: 7px;
      height: 7px;
      background: #b8c1d9;
      border-radius: 50%;
      animation: wv-bounce 1.2s infinite;
    }
    .wv-typing-dots span:nth-child(2) { animation-delay: 0.2s; }
    .wv-typing-dots span:nth-child(3) { animation-delay: 0.4s; }
    @keyframes wv-bounce {
      0%, 80%, 100% { transform: translateY(0); }
      40% { transform: translateY(-6px); }
    }

    /* ── Product cards ─────────────────────────────────────────────────── */
    .wv-product-cards {
      display: flex;
      flex-direction: column;
      gap: 8px;
      align-self: stretch;
      max-width: 90%;
      margin: 2px 0;
    }
    .wv-product-card {
      display: flex;
      align-items: center;
      gap: 13px;
      background: #fff;
      border: 1px solid #e3e8f2;
      border-radius: 14px;
      padding: 11px;
      text-decoration: none;
      color: inherit;
      box-shadow: 0 1px 3px rgba(50,50,83,0.05);
      transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms cubic-bezier(0.23, 1, 0.32, 1);
      cursor: pointer;
    }
    @media (hover: hover) and (pointer: fine) {
      .wv-product-card:hover { border-color: ${BRAND_COLOR}; box-shadow: 0 4px 14px rgba(62,86,135,0.16); transform: translateY(-1px); }
    }
    .wv-product-card-img {
      width: 64px;
      height: 64px;
      object-fit: contain;
      border-radius: 8px;
      background: #f5f7fc;
      flex-shrink: 0;
    }
    .wv-product-card-info { flex: 1; min-width: 0; }
    .wv-product-card-name {
      font-size: 14px;
      font-weight: 600;
      color: #1a1a1a;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .wv-product-card-price { font-size: 14px; color: ${BRAND_COLOR}; font-weight: 700; margin-top: 3px; }
    .wv-product-card-cta { font-size: 11.5px; color: #9aa1b5; margin-top: 4px; }

    /* ── Buttons ─────────────────────────────────────────────────────── */
    .wv-whatsapp-cta {
      margin: 4px 0 2px;
      background: #25D366;
      color: #fff;
      border: none;
      border-radius: 100px;
      padding: 11px 20px;
      font-size: 13.5px;
      font-weight: 600;
      font-family: inherit;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      align-self: flex-start;
      max-width: 88%;
      box-shadow: 0 2px 8px rgba(37,211,102,0.3);
      transition: background 150ms ease, transform 150ms cubic-bezier(0.23, 1, 0.32, 1), box-shadow 150ms ease;
    }
    .wv-whatsapp-cta:hover { background: #20b858; }
    @media (hover: hover) and (pointer: fine) {
      .wv-whatsapp-cta:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(37,211,102,0.4); }
    }
    .wv-whatsapp-cta svg { width: 18px; height: 18px; fill: #fff; flex-shrink: 0; }

    .wv-chips {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      align-self: flex-start;
      max-width: 90%;
      margin: 2px 0 4px;
      animation: wv-msg-in 220ms cubic-bezier(0.23, 1, 0.32, 1);
    }
    .wv-chip {
      background: #fff;
      color: ${BRAND_COLOR};
      border: 1.5px solid ${BRAND_COLOR};
      border-radius: 100px;
      padding: 10px 16px;
      min-height: 40px;
      font-size: 13.5px;
      font-weight: 600;
      font-family: inherit;
      cursor: pointer;
      transition: background 150ms ease, color 150ms ease, transform 150ms cubic-bezier(0.23, 1, 0.32, 1);
    }
    .wv-chip:active { transform: scale(0.97); }
    @media (hover: hover) and (pointer: fine) {
      .wv-chip:hover { background: ${BRAND_COLOR}; color: #fff; transform: translateY(-1px); }
    }

    .wv-checkout-btn {
      margin: 4px 0 2px;
      background: ${BRAND_COLOR};
      color: #fff;
      border: none;
      border-radius: 100px;
      padding: 12px 22px;
      font-size: 14px;
      font-weight: 700;
      font-family: inherit;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      align-self: flex-start;
      max-width: 88%;
      text-decoration: none;
      box-shadow: 0 3px 10px rgba(62,86,135,0.30);
      transition: background 150ms ease, transform 150ms cubic-bezier(0.23, 1, 0.32, 1);
    }
    .wv-checkout-btn:hover { background: #2d3f6a; }
    @media (hover: hover) and (pointer: fine) {
      .wv-checkout-btn:hover { transform: translateY(-1px); }
    }

    .wv-order-confirm-btn {
      margin: 4px 0 2px;
      background: #25D366;
      color: #fff;
      border: none;
      border-radius: 100px;
      padding: 10px 14px;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      align-self: flex-start;
      max-width: 88%;
      text-decoration: none;
      transition: background 0.2s;
    }
    .wv-order-confirm-btn:hover { background: #20b858; }

    .wv-confirm-order-btn {
      margin: 4px 0 2px;
      background: ${BRAND_COLOR};
      color: #fff;
      border: none;
      border-radius: 100px;
      padding: 12px 20px;
      font-size: 14px;
      font-weight: 700;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      align-self: flex-start;
      max-width: 88%;
      transition: background 0.2s;
    }
    .wv-confirm-order-btn:hover { background: #2d3f6a; }
    .wv-confirm-order-btn:disabled { background: #aaa; cursor: not-allowed; }

    /* ── Customer confirm card ─────────────────────────────────────────── */
    .wv-customer-card {
      background: #f7f9ff;
      border: 1px solid #dce4f5;
      border-radius: 12px;
      padding: 12px 14px;
      margin: 4px 0 8px;
      align-self: flex-start;
      max-width: 92%;
      font-size: 13.5px;
      color: #1a2555;
    }
    .wv-customer-card-row { margin-bottom: 3px; }
    .wv-customer-card-actions { display: flex; gap: 8px; margin-top: 10px; }
    .wv-customer-card-yes {
      flex: 1; background: ${BRAND_COLOR}; color: #fff;
      border: none; border-radius: 8px; padding: 9px 10px;
      font-size: 13px; font-weight: 700; cursor: pointer; transition: background 0.2s;
    }
    .wv-customer-card-yes:hover { background: #2d3f6a; }
    .wv-customer-card-no {
      flex: 1; background: #fff; color: #555;
      border: 1px solid #ccc; border-radius: 8px; padding: 9px 10px;
      font-size: 13px; font-weight: 600; cursor: pointer; transition: background 0.2s;
    }
    .wv-customer-card-no:hover { background: #f0f0f0; }

    /* ── Inline order form ─────────────────────────────────────────── */
    .wv-order-form {
      align-self: stretch;
      background: #fff;
      border: 1px solid #e3e8f2;
      border-radius: 14px;
      padding: 15px;
      display: flex;
      flex-direction: column;
      gap: 8px;
      box-shadow: 0 1px 3px rgba(50,50,83,0.05);
    }
    .wv-order-form-title {
      font-family: 'Playfair Display', Georgia, serif;
      font-style: italic;
      font-size: 15.5px;
      font-weight: 600;
      color: #323253;
      margin: 0 0 4px;
    }
    .wv-order-form input {
      border: 1px solid #e3e8f2;
      border-radius: 10px;
      padding: 10px 12px;
      font-size: 16px; /* 16px prevents iOS auto-zoom */
      font-family: inherit;
      outline: none;
      background: #f4f7ff;
      transition: border-color 150ms ease, background 150ms ease;
    }
    .wv-order-form input:focus { border-color: ${BRAND_COLOR}; background: #fff; }
    .wv-order-form input.wv-field-error { border-color: #e53935; }
    .wv-order-form input.wv-field-check { border-color: ${BRAND_COLOR}; background: #fff; }
    .wv-form-prefill-note {
      font-size: 12px; color: #5a5a72; line-height: 1.45; margin: -2px 0 4px;
    }
    .wv-form-prefill-note strong { color: #323253; }
    .wv-order-form input:disabled { background: #f5f5f5; color: #999; }
    .wv-form-error-msg {
      font-size: 11px;
      color: #e53935;
      display: none;
      margin-top: -4px;
    }
    .wv-form-submit-btn {
      background: ${BRAND_COLOR};
      color: #fff;
      border: none;
      border-radius: 100px;
      padding: 12px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      margin-top: 2px;
      transition: background 0.2s;
    }
    .wv-form-submit-btn:hover { background: #2d3f6a; }
    .wv-form-submit-btn:disabled { background: #aaa; cursor: not-allowed; }

    /* ── Footer ──────────────────────────────────────────────────────── */
    .wv-footer {
      padding: 12px 14px;
      padding-bottom: max(12px, env(safe-area-inset-bottom));
      border-top: 1px solid #e3e8f2;
      display: flex;
      gap: 9px;
      align-items: flex-end;
      background: #fff;
      flex-shrink: 0;
    }
    .wv-input {
      flex: 1;
      border: 1.5px solid #e3e8f2;
      border-radius: 22px;
      padding: 11px 18px;
      font-size: 14px;
      outline: none;
      resize: none;
      line-height: 1.4;
      max-height: 80px;
      overflow-y: auto;
      font-family: inherit;
      background: #f4f7ff;
      -webkit-appearance: none;
      transition: border-color 150ms ease, background 150ms ease;
    }
    .wv-input:focus { border-color: ${BRAND_COLOR}; background: #fff; }
    .wv-send-btn {
      width: 42px;
      height: 42px;
      min-width: 42px;
      border-radius: 50%;
      background: ${BRAND_COLOR};
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      transition: background 150ms ease, transform 150ms cubic-bezier(0.23, 1, 0.32, 1);
    }
    .wv-send-btn:hover { background: #2d3f6a; }
    @media (hover: hover) and (pointer: fine) {
      .wv-send-btn:hover { transform: scale(1.05); }
    }
    .wv-send-btn:disabled { background: #ccc; cursor: not-allowed; transform: none; }
    .wv-send-btn svg { width: 18px; height: 18px; fill: #fff; }

    .wv-powered {
      text-align: center;
      font-size: 10.5px;
      color: #b8bece;
      padding: 5px 0 7px;
      flex-shrink: 0;
      background: #fff;
    }
    .wv-powered em { font-family: 'Playfair Display', Georgia, serif; font-style: italic; }

    /* ── Mobile overrides ────────────────────────────────────────────── */
    @media (max-width: 480px) {
      #wv-chat-window {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        border-radius: 0;
        z-index: 10000;
      }
      #wv-chat-bubble { bottom: 16px; right: 16px; }
      .wv-input { font-size: 16px; }
      .wv-msg { max-width: 88%; }
      .wv-product-cards { max-width: 96%; }
    }
  `;
  document.head.appendChild(style);

  // HTML structure
  const bubble = document.createElement('div');
  bubble.id = 'wv-chat-bubble';
  bubble.innerHTML = `
    <video class="wv-bubble-emoji" autoplay loop muted playsinline preload="auto">
      <source src="https://cdn.shopify.com/s/files/1/0816/8446/3933/t/28/assets/aicha-avatar.mp4?v=1778961517" type="video/mp4">
    </video>
    <img class="wv-bubble-logo wv-hidden" src="https://cdn.shopify.com/s/files/1/0816/8446/3933/files/wellvita_-_logo_87a84761-ff84-4f5c-a203-735e6d882e1d.png" alt="WellVita" loading="eager">
    <span class="wv-badge" id="wv-badge">1</span>
  `;

  const chatWindow = document.createElement('div');
  chatWindow.id = 'wv-chat-window';
  chatWindow.innerHTML = `
    <div class="wv-header">
      <div class="wv-header-avatar">
        <video autoplay loop muted playsinline preload="auto">
          <source src="https://cdn.shopify.com/s/files/1/0816/8446/3933/t/28/assets/aicha-avatar.mp4?v=1778961517" type="video/mp4">
        </video>
      </div>
      <div class="wv-header-info">
        <div class="wv-header-name">Aïcha</div>
        <div class="wv-header-sub">Votre conseillère bien-être WellVita</div>
        <div class="wv-header-status"><span class="wv-header-dot"></span> En ligne — répond en quelques secondes</div>
      </div>
      <span class="wv-close-btn" id="wv-close">✕</span>
    </div>
    <div class="wv-messages" id="wv-messages"></div>
    <div class="wv-footer">
      <textarea class="wv-input" id="wv-input" placeholder="Posez votre question…" rows="1"></textarea>
      <button class="wv-send-btn" id="wv-send">
        <svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
      </button>
    </div>
    <div class="wv-powered">Propulsé par <em>WellVita IA</em></div>
  `;

  // Welcome notification bubble
  const notif = document.createElement('div');
  notif.id = 'wv-chat-notif';
  notif.classList.add('wv-hidden');
  // Notification contextuelle : le message s'adapte à la page visitée (fallback = texte générique)
  function getNotifTexts() {
    var title = 'Une question bien-être ?';
    var sub = 'Aïcha, votre conseillère, vous répond en quelques secondes.';
    try {
      var path = window.location.pathname;
      if (path.indexOf('/products/') !== -1) {
        // Titre produit : d'abord le heading de la fiche (propre), sinon og:title nettoyé du suffixe SEO
        var hEl = document.querySelector('.product__title h1, .product__title h2, [id^="ProductInfo"] h1, [id^="ProductInfo"] h2');
        var og = document.querySelector('meta[property="og:title"]');
        var pname = hEl ? hEl.textContent.trim()
          : ((og && og.content) ? og.content.split('|')[0].split('–')[0].split(':')[0].replace(/\s+Abidjan\s*$/i, '').trim() : '');
        if (pname.length > 34) pname = pname.slice(0, 32).trim() + '…';
        if (pname) {
          title = 'Une question sur ' + pname + ' ?';
          sub = 'Aïcha connaît ce produit par cœur — bienfaits, posologie, livraison.';
        }
      } else if (path.indexOf('/collections/') !== -1) {
        title = 'Besoin d\'aide pour choisir ?';
        sub = 'Aïcha vous guide vers le bon produit en quelques questions.';
      } else if (path.indexOf('/cart') !== -1) {
        title = 'Une question avant de commander ?';
        sub = 'Livraison, paiement, conseils — Aïcha vous répond tout de suite.';
      }
    } catch (e) {}
    return { title: title, sub: sub };
  }
  var notifTexts = getNotifTexts();
  notif.innerHTML = `
    <span class="wv-notif-close" id="wv-notif-close">✕</span>
    <p class="wv-notif-title">${escapeHtml(notifTexts.title)}</p>
    <p class="wv-notif-sub">${escapeHtml(notifTexts.sub)}</p>
    <span class="wv-notif-cta">Démarrer la conversation →</span>
  `;

  const ripple = document.createElement('div');
  ripple.id = 'wv-bubble-ripple';
  document.body.appendChild(ripple);
  document.body.appendChild(bubble);
  document.body.appendChild(notif);
  document.body.appendChild(chatWindow);

  // Cute two-tone chime using Web Audio API
  function playChime() {
    try {
      var ctx = new (window.AudioContext || window.webkitAudioContext)();
      var t = ctx.currentTime;
      [[880, 0, 0.35], [1108, 0.15, 0.45]].forEach(function(n) {
        var o = ctx.createOscillator();
        var g = ctx.createGain();
        o.connect(g); g.connect(ctx.destination);
        o.type = 'sine';
        o.frequency.value = n[0];
        g.gain.setValueAtTime(0, t + n[1]);
        g.gain.linearRampToValueAtTime(0.12, t + n[1] + 0.015);
        g.gain.exponentialRampToValueAtTime(0.001, t + n[1] + n[2]);
        o.start(t + n[1]); o.stop(t + n[1] + n[2]);
      });
    } catch(e) {}
  }

  // Show notif after delay — once per page load (session only, no localStorage cooldown)
  (function () {
    var notifDismissed = false;
    setTimeout(function () {
      if (!isOpen && !notifDismissed) {
        notif.classList.remove('wv-hidden');
        playChime();
      }
    }, 15000);

    document.getElementById('wv-notif-close').addEventListener('click', function (e) {
      e.stopPropagation();
      notif.classList.add('wv-hidden');
      notifDismissed = true;
    });
    notif.addEventListener('click', function () {
      notif.classList.add('wv-hidden');
      notifDismissed = true;
      openChat();
    });
  })();

  // State
  let isOpen = false;
  let isWaiting = false;
  let _savedScrollY = 0;
  let _vpListener = null;
  let _closeTimer = null;

  const messagesEl = document.getElementById('wv-messages');
  const inputEl = document.getElementById('wv-input');
  const sendBtn = document.getElementById('wv-send');
  const badge = document.getElementById('wv-badge');

  // Render inline order form
  function renderOrderForm(products, prefillValues, fromProfile) {
    prefillValues = prefillValues || {};
    var formEl = document.createElement('div');
    formEl.className = 'wv-order-form';
    var title = fromProfile ? '📋 Vérifiez vos informations de livraison' : '📦 Informations de livraison';
    var submitLabel = fromProfile ? '✅ Confirmer ces informations' : '✅ Valider les informations';
    formEl.innerHTML =
      '<p class="wv-order-form-title">' + title + '</p>' +
      (fromProfile ? '<p class="wv-form-prefill-note">Vos informations de votre dernière commande — <strong>vérifiez bien l\'adresse de livraison</strong> avant de confirmer.</p>' : '') +
      '<input type="text" placeholder="Prénom *" data-field="prenom" autocomplete="given-name">' +
      '<input type="text" placeholder="Nom de famille *" data-field="nom" autocomplete="family-name">' +
      '<input type="text" placeholder="Adresse (rue, quartier) *" data-field="adresse" autocomplete="address-line1">' +
      '<input type="text" placeholder="Ville *" data-field="ville" autocomplete="address-level2">' +
      '<input type="tel" placeholder="Numéro WhatsApp (+225...) *" data-field="tel" autocomplete="tel">' +
      '<div class="wv-form-error-msg" id="wv-form-err">Veuillez remplir tous les champs obligatoires.</div>' +
      '<button class="wv-form-submit-btn" id="wv-form-submit">' + submitLabel + '</button>';

    // Pre-fill saved values (brouillon restauré ou profil client reconnu)
    formEl.querySelectorAll('input').forEach(function (inp) {
      if (prefillValues[inp.dataset.field]) inp.value = prefillValues[inp.dataset.field];
    });
    // Client reconnu : adresse mise en évidence pour confirmation visuelle
    if (fromProfile) {
      var adrInp = formEl.querySelector('input[data-field="adresse"]');
      if (adrInp) adrInp.classList.add('wv-field-check');
    }

    // Persist form state + field values on each keystroke
    function savePendingForm() {
      var values = {};
      formEl.querySelectorAll('input').forEach(function (inp) { values[inp.dataset.field] = inp.value; });
      try {
        localStorage.setItem('wv_pending_form', JSON.stringify({ products: products, values: values, ts: Date.now(), sid: sessionId }));
      } catch (e) {}
    }
    savePendingForm(); // save immediately so form survives a reload even before any input
    formEl.querySelectorAll('input').forEach(function (inp) {
      inp.addEventListener('input', savePendingForm);
    });

    var submitBtn = formEl.querySelector('#wv-form-submit');
    var errEl = formEl.querySelector('#wv-form-err');

    submitBtn.addEventListener('click', function () {
      var fields = {};
      var valid = true;
      formEl.querySelectorAll('input').forEach(function (inp) {
        var val = inp.value.trim();
        var fieldValid = !!val;
        if (fieldValid && inp.dataset.field === 'tel') {
          var digits = val.replace(/[\s+\-().]/g, '');
          if (!/^\d{8,15}$/.test(digits)) fieldValid = false;
        }
        if (!fieldValid) { valid = false; inp.classList.add('wv-field-error'); }
        else { inp.classList.remove('wv-field-error'); }
        fields[inp.dataset.field] = val;
      });
      if (!valid) { errEl.style.display = 'block'; return; }
      errEl.style.display = 'none';
      submitBtn.disabled = true;
      submitBtn.textContent = '⏳ Traitement en cours...';
      formEl.querySelectorAll('input').forEach(function (inp) { inp.disabled = true; });
      submitOrder(fields, products, formEl);
    });

    messagesEl.appendChild(formEl);
    scrollToBottom();
    setTimeout(function () {
      var firstInput = formEl.querySelector('input[value=""]') || formEl.querySelector('input');
      if (firstInput) firstInput.focus();
    }, 100);
  }

  function restorePendingForm() {
    try {
      var raw = localStorage.getItem('wv_pending_form');
      if (!raw) return;
      var pending = JSON.parse(raw);
      // Expire after 2 hours or if session changed
      if (!pending.products || (Date.now() - pending.ts) > 2 * 60 * 60 * 1000 || pending.sid !== sessionId) {
        localStorage.removeItem('wv_pending_form');
        return;
      }
      renderOrderForm(pending.products, pending.values || {});
    } catch (e) {
      localStorage.removeItem('wv_pending_form');
    }
  }

  // Submit order (CAS A — form filled)
  function submitOrder(formData, products, formEl) {
    addMessage('', 'typing');
    wvFetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId, action: 'create_order', form_data: formData, produits: products })
    })
    .then(function (res) { if (!res.ok) throw new Error(); return res.json().catch(function() { throw new Error(); }); })
    .then(function (data) {
      try { localStorage.removeItem('wv_pending_form'); } catch(e) {}
      if (formEl && formEl.parentNode) formEl.remove();
      addMessage(data.response || 'Commande enregistrée !', 'bot', {
        suggest_whatsapp:      data.suggest_whatsapp,
        order_url:             data.order_url,
        checkout_url:          data.checkout_url || null,
        show_confirm_button:   data.show_confirm_button || false,
        draft_order_id:        data.draft_order_id || null,
        show_customer_confirm: data.show_customer_confirm || false,
        existing_customer:     data.existing_customer || null,
        original_form_data:    data.original_form_data || null
      });
    })
    .catch(function () {
      if (formEl) {
        var btn = formEl.querySelector('#wv-form-submit');
        if (btn) { btn.disabled = false; btn.textContent = '✅ Valider les informations'; }
        formEl.querySelectorAll('input').forEach(function (inp) { inp.disabled = false; });
      }
      addMessage("Désolée, une erreur technique s'est produite. Réessayez ou contactez-nous directement 👇", 'bot', { suggest_whatsapp: true });
    });
  }

  // Helper — create and append the confirm button (reused on init restore too)
  function appendConfirmButton(draftOrderId) {
    var confirmBtn = document.createElement('button');
    confirmBtn.className = 'wv-confirm-order-btn';
    confirmBtn.textContent = '✅ Confirmer ma commande';
    (function (btn, oid) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        btn.textContent = '⏳ Confirmation en cours...';
        submitConfirmOrder(oid, btn);
      });
    })(confirmBtn, draftOrderId);
    messagesEl.appendChild(confirmBtn);
    scrollToBottom();
  }

  // Confirm draft order (from Order Response confirm button)
  function submitConfirmOrder(draftOrderId, btn) {
    addMessage('', 'typing');
    wvFetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId, action: 'confirm_order', draft_order_id: draftOrderId })
    })
    .then(function (res) { if (!res.ok) throw new Error(); return res.json().catch(function() { throw new Error(); }); })
    .then(function (data) {
      try { localStorage.removeItem('wv_pending_confirm'); } catch(e) {}
      if (btn && btn.parentNode) btn.remove();
      addMessage(data.response || 'Commande confirmée !', 'bot', { suggest_whatsapp: data.suggest_whatsapp, order_url: data.order_url });
    })
    .catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = '✅ Confirmer ma commande'; }
      addMessage("Erreur lors de la confirmation. Réessayez ou contactez-nous directement 👇", 'bot', { suggest_whatsapp: true });
    });
  }

  // Restore pending confirm button after page refresh (expires after 30 min)
  function restorePendingConfirm() {
    try {
      var raw = localStorage.getItem('wv_pending_confirm');
      if (!raw) return;
      var pending = JSON.parse(raw);
      if (!pending.draft_order_id || (Date.now() - pending.ts) > 30 * 60 * 1000) {
        localStorage.removeItem('wv_pending_confirm');
        return;
      }
      appendConfirmButton(pending.draft_order_id);
    } catch (e) {}
  }

  // Direct order (CAS B — info already known, creates then confirms in one shot)
  function submitDirectOrder(formData, products, confirmBtn) {
    if (confirmBtn) { confirmBtn.disabled = true; confirmBtn.textContent = '⏳ Traitement en cours...'; }
    addMessage('', 'typing');
    wvFetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId, action: 'create_order', form_data: formData, produits: products })
    })
    .then(function (res) { if (!res.ok) throw new Error(); return res.json().catch(function() { throw new Error(); }); })
    .then(function (data) {
      if (confirmBtn && confirmBtn.parentNode) confirmBtn.remove();
      if (data.draft_order_id) {
        return wvFetch(WEBHOOK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId, action: 'confirm_order', draft_order_id: data.draft_order_id })
        }).then(function (res) { if (!res.ok) throw new Error(); return res.json().catch(function() { throw new Error(); }); });
      }
      return data;
    })
    .then(function (data) {
      addMessage(data.response || 'Commande confirmée ! 🎉', 'bot', { suggest_whatsapp: data.suggest_whatsapp, order_url: data.order_url });
    })
    .catch(function () {
      if (confirmBtn) { confirmBtn.disabled = false; confirmBtn.textContent = '✅ Oui, confirmer ma commande'; }
      addMessage("Désolée, une erreur technique s'est produite. Réessayez ou contactez-nous directement 👇", 'bot', { suggest_whatsapp: true });
    });
  }

  // Render product cards
  function renderProductCards(cards) {
    if (!cards || !cards.length) return;
    var container = document.createElement('div');
    container.className = 'wv-product-cards';
    try { container.dataset.wvCards = JSON.stringify(cards); } catch(e) {}
    cards.forEach(function(card) {
      var a = document.createElement('a');
      a.className = 'wv-product-card';
      a.href = card.url || 'https://wellvita-ci.com/products/' + (card.handle || '');
      a.target = '_self';
      var imgHtml = card.image
        ? '<img class="wv-product-card-img" src="' + escapeHtml(card.image) + '?width=200" alt="' + escapeHtml(card.name) + '" loading="lazy" onerror="this.style.display=\'none\'">'
        : '';
      a.innerHTML = imgHtml +
        '<div class="wv-product-card-info">' +
          '<div class="wv-product-card-name">' + escapeHtml(card.name) + '</div>' +
          (card.price ? '<div class="wv-product-card-price">' + escapeHtml(String(card.price)) + ' FCFA</div>' : '') +
          '<div class="wv-product-card-cta">Voir le produit →</div>' +
        '</div>';
      container.appendChild(a);
    });
    messagesEl.appendChild(container);
  }

  // Add message bubble (or typing indicator)
  function sendCustomerConfirm(useExisting) {
    try {
      var raw = localStorage.getItem('wv_pending_customer_confirm');
      if (!raw) return;
      var wrapper = JSON.parse(raw);
      var pending = wrapper.data || wrapper;
      if (wrapper.ts && (Date.now() - wrapper.ts) > 30 * 60 * 1000) {
        localStorage.removeItem('wv_pending_customer_confirm');
        return;
      }
    } catch(e) {
      try { localStorage.removeItem('wv_pending_customer_confirm'); } catch(e2) {}
      return;
    }
    addMessage('', 'typing');
    wvFetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session_id: sessionId,
        action: 'customer_confirmed',
        use_existing: useExisting,
        existing_customer_id: pending.existing_customer_id || null,
        form_data: pending.form_data,
        produits: pending.produits
      })
    })
    .then(function(r) { if (!r.ok) throw new Error(); return r.json().catch(function() { throw new Error(); }); })
    .then(function(data) {
      localStorage.removeItem('wv_pending_customer_confirm');
      addMessage(data.response || 'Parfait, je prépare votre commande !', 'bot', {
        checkout_url: data.checkout_url || null,
        draft_order_id: data.draft_order_id || null,
        show_confirm_button: data.show_confirm_button || false
      });
    })
    .catch(function() {
      addMessage("Désolée, une erreur est survenue. Réessayez ou contactez-nous directement 👇", 'bot', { suggest_whatsapp: true });
    });
  }

  function addMessage(text, role, options) {
    options = options || {};
    var suggest_whatsapp   = options.suggest_whatsapp;
    var order_url          = options.order_url;
    var trigger_form       = options.trigger_form;
    var form_products      = options.form_products || [];
    var show_confirm_button = options.show_confirm_button;
    var draft_order_id     = options.draft_order_id || null;
    var product_cards      = options.product_cards || [];
    var show_customer_confirm = options.show_customer_confirm || false;
    var existing_customer  = options.existing_customer || null;
    var original_form_data = options.original_form_data || null;

    if (role === 'typing') {
      var typing = document.createElement('div');
      typing.className = 'wv-msg typing';
      typing.id = 'wv-typing';
      typing.innerHTML = '<div class="wv-typing-dots"><span></span><span></span><span></span></div>';
      messagesEl.appendChild(typing);
      scrollToBottom();
      return;
    }

    var existingTyping = document.getElementById('wv-typing');
    if (existingTyping) existingTyping.remove();

    if (text) {
      var el = document.createElement('div');
      el.className = 'wv-msg ' + role;
      el.innerHTML = role === 'bot' ? renderMarkdown(text) : escapeHtml(text).replace(/\n/g, '<br>');
      messagesEl.appendChild(el);
    }

    // Product cards (shown after the message, before action buttons)
    if (product_cards.length > 0) {
      renderProductCards(product_cards);
    }

    // WhatsApp button
    if (suggest_whatsapp) {
      messagesEl.appendChild(makeWaBtn());
    }

    // Bouton checkout (commande hors zone Abidjan -> paiement mobile en ligne)
    if (options.checkout_url) {
      messagesEl.appendChild(makeCheckoutBtn(options.checkout_url));
    }

    // Quick replies (chips éphémères, non persistées)
    if (options.chips && options.chips.length > 0 && role === 'bot') {
      messagesEl.appendChild(makeChips(options.chips));
      scrollToBottom();
    }

    // Customer confirm card (existing client found)
    if (show_customer_confirm && existing_customer) {
      if (original_form_data) {
        try { localStorage.setItem('wv_pending_customer_confirm', JSON.stringify({ data: original_form_data, ts: Date.now() })); } catch(e) {}
      }
      var card = document.createElement('div');
      card.className = 'wv-customer-card';
      var rows = '';
      if (existing_customer.prenom || existing_customer.nom) {
        rows += '<div class="wv-customer-card-row">📛 <strong>' + escapeHtml(existing_customer.prenom) + ' ' + escapeHtml(existing_customer.nom) + '</strong></div>';
      }
      if (existing_customer.adresse) {
        rows += '<div class="wv-customer-card-row">📍 ' + escapeHtml(existing_customer.adresse) + (existing_customer.ville ? ', ' + escapeHtml(existing_customer.ville) : '') + '</div>';
      } else if (existing_customer.ville) {
        rows += '<div class="wv-customer-card-row">📍 ' + escapeHtml(existing_customer.ville) + '</div>';
      }
      if (existing_customer.tel) {
        rows += '<div class="wv-customer-card-row">📱 ' + escapeHtml(existing_customer.tel) + '</div>';
      }
      card.innerHTML = rows + '<div class="wv-customer-card-actions">' +
        '<button class="wv-customer-card-yes" id="wv-cust-yes">✅ Oui, c\'est correct</button>' +
        '<button class="wv-customer-card-no" id="wv-cust-no">✏️ Modifier</button>' +
        '</div>';
      messagesEl.appendChild(card);
      card.querySelector('#wv-cust-yes').addEventListener('click', function() {
        card.querySelector('#wv-cust-yes').disabled = true;
        card.querySelector('#wv-cust-no').disabled = true;
        sendCustomerConfirm(true);
      });
      card.querySelector('#wv-cust-no').addEventListener('click', function() {
        card.querySelector('#wv-cust-yes').disabled = true;
        card.querySelector('#wv-cust-no').disabled = true;
        sendCustomerConfirm(false);
      });
    }

    // In-chat confirm button (from Order Response — after create_order)
    if (show_confirm_button && draft_order_id) {
      localStorage.setItem('wv_pending_confirm', JSON.stringify({ draft_order_id: draft_order_id, ts: Date.now() }));
      appendConfirmButton(draft_order_id);
    }

    // WhatsApp link after order confirmed
    if (order_url) {
      var waOrderBtn = document.createElement('a');
      waOrderBtn.className = 'wv-order-confirm-btn';
      waOrderBtn.href = order_url;
      waOrderBtn.target = '_blank';
      waOrderBtn.rel = 'noopener';
      waOrderBtn.innerHTML = `
        <svg viewBox="0 0 24 24" width="18" height="18" fill="#fff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.114.554 4.1 1.525 5.823L.057 23.5l5.808-1.524A11.953 11.953 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.907 0-3.697-.5-5.25-1.377l-.375-.223-3.447.903.923-3.369-.245-.389A9.96 9.96 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/></svg>
        Confirmer sur WhatsApp
      `;
      messagesEl.appendChild(waOrderBtn);
    }

    scrollToBottom();
    if (role === 'bot' && !trigger_form) {
      try { localStorage.removeItem('wv_pending_form'); } catch(e) {}
    }
    saveMessages();

    // Render inline form after short delay
    if (trigger_form && form_products.length > 0) {
      setTimeout(function () { renderOrderForm(form_products, options.form_prefill || {}, !!options.form_prefill); }, 350);
    }
  }

  function scrollToBottom() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // Délai de frappe réaliste — proportionnel à la longueur de réponse
  // min 1.5s, max 3.5s, ~22ms par caractère
  function typingDelay(text) {
    return Math.min(3500, Math.max(1500, (text || '').length * 22));
  }

  // Send chat message to n8n
  function sendMessage(text) {
    if (!text.trim() || isWaiting) return;

    removeChips(); // les quick replies sont éphémères : un envoi les retire
    addMessage(text, 'user');
    inputEl.value = '';
    inputEl.style.height = 'auto';
    isWaiting = true;
    sendBtn.disabled = true;
    addMessage('', 'typing');
    var fetchStart = Date.now();

    wvFetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId, message: text })
    })
    .then(function (res) { if (!res.ok) throw new Error(); return res.json().catch(function() { throw new Error(); }); })
    .then(function (data) {
      var responseText = data.response || "Désolée, je n'ai pas pu répondre. Réessayez !";
      var delay = typingDelay(responseText);
      var elapsed = Date.now() - fetchStart;
      var remaining = Math.max(0, delay - elapsed);

      setTimeout(function () {
        addMessage(responseText, 'bot', {
          suggest_whatsapp:      data.suggest_whatsapp || /07[\s.]?00[\s.]?10[\s.]?67[\s.]?10|whatsapp/i.test(responseText),
          order_url:             data.order_url || null,
          trigger_form:          data.trigger_form,
          form_prefill:          data.form_prefill || null,
          chips:                 data.chips || [],
          form_products:         data.form_products || [],
          show_confirm_button:   data.show_confirm_button || false,
          draft_order_id:        data.draft_order_id || null,
          product_cards:         data.product_cards || [],
          show_customer_confirm: data.show_customer_confirm || false,
          existing_customer:     data.existing_customer || null,
          original_form_data:    data.original_form_data || null
        });
        // CAS B — direct confirm button
        if (data.action_directe && data.form_data_directe) {
          var _fd = data.form_data_directe;
          var _prods = data.form_products || [];
          var _btn = document.createElement('button');
          _btn.className = 'wv-confirm-order-btn';
          _btn.textContent = '✅ Oui, confirmer ma commande';
          (function (fd, prods, btn) {
            btn.addEventListener('click', function () { submitDirectOrder(fd, prods, btn); });
          })(_fd, _prods, _btn);
          messagesEl.appendChild(_btn);
          scrollToBottom();
          saveMessages();
        }
        isWaiting = false;
        sendBtn.disabled = false;
        if (!IS_MOBILE()) inputEl.focus();
      }, remaining);
    })
    .catch(function () {
      addMessage("Notre connexion est instable 😕 Réessayez dans quelques secondes ou contactez-nous directement 👇", 'bot', { suggest_whatsapp: true });
      isWaiting = false;
      sendBtn.disabled = false;
      if (!IS_MOBILE()) inputEl.focus();
    });
  }

  function openChat() {
    isOpen = true;
    // Annule une fermeture animée en cours (clic rapide ouvrir/fermer)
    if (_closeTimer) { clearTimeout(_closeTimer); _closeTimer = null; }
    chatWindow.classList.remove('wv-closing');
    chatWindow.classList.add('open');
    badge.style.display = 'none';
    notif.classList.add('wv-hidden');
    ripple.classList.add('wv-hidden');
    bubble.classList.add('wv-open');
    bubble.classList.add('wv-hidden');
    var emojiEl = bubble.querySelector('.wv-bubble-emoji');
    if (emojiEl) { emojiEl.classList.add('wv-hidden'); if (emojiEl.pause) emojiEl.pause(); }
    bubble.querySelector('img.wv-bubble-logo').classList.remove('wv-hidden');

    // Mobile: full-screen chat via visualViewport (no body lock needed)
    if (IS_MOBILE()) {
      if (window.visualViewport) {
        var _rafId = null;
        var _footerEl = chatWindow.querySelector('.wv-footer');
        _vpListener = function () {
          if (_rafId) cancelAnimationFrame(_rafId);
          _rafId = requestAnimationFrame(function () {
            var vp = window.visualViewport;
            chatWindow.style.top = vp.offsetTop + 'px';
            chatWindow.style.height = vp.height + 'px';
            chatWindow.style.bottom = 'auto';
            chatWindow.style.left = '0';
            chatWindow.style.right = '0';
            chatWindow.style.width = '100%';
            // Neutralise safe-area-inset-bottom quand le clavier est ouvert
            // (vp.height < window.screen.height × 0.75 = clavier probablement ouvert)
            if (_footerEl) {
              var keyboardOpen = vp.height < window.screen.height * 0.75;
              _footerEl.style.paddingBottom = keyboardOpen ? '10px' : '';
            }
            messagesEl.scrollTop = messagesEl.scrollHeight;
            _rafId = null;
          });
        };
        window.visualViewport.addEventListener('resize', _vpListener);
        window.visualViewport.addEventListener('scroll', _vpListener);
        _vpListener();
      }
    }

    if (messagesEl.children.length === 0) {
      var restored = restoreMessages();
      if (restored) {
        restorePendingConfirm();
        restorePendingForm();
      }
      if (!restored) {
        setTimeout(function () {
          addMessage(
            "Bonjour ! Je suis Aïcha, conseillère chez WellVita CI 🌿\n\nJe suis là pour vous conseiller, vous guider dans le choix de vos compléments alimentaires, et prendre votre commande si vous le souhaitez.\n\nQu'est-ce que vous cherchez à améliorer aujourd'hui ?",
            'bot'
          );
        }, 400);
      }
    }
    setTimeout(function () { inputEl.focus(); }, 100);
  }

  function closeChat() {
    isOpen = false;
    // Desktop : fermeture animée (la classe wv-closing maintient display:flex pendant l'animation)
    if (!IS_MOBILE() && chatWindow.classList.contains('open')) {
      chatWindow.classList.add('wv-closing');
      chatWindow.classList.remove('open');
      if (_closeTimer) clearTimeout(_closeTimer);
      _closeTimer = setTimeout(function () {
        chatWindow.classList.remove('wv-closing');
        _closeTimer = null;
      }, 210);
    } else {
      chatWindow.classList.remove('open');
    }
    bubble.classList.remove('wv-hidden');
    bubble.classList.remove('wv-open');
    ripple.classList.remove('wv-hidden');
    var emojiEl = bubble.querySelector('.wv-bubble-emoji');
    if (emojiEl) { emojiEl.classList.remove('wv-hidden'); if (emojiEl.play) emojiEl.play(); }
    bubble.querySelector('img.wv-bubble-logo').classList.add('wv-hidden');
    chatWindow.style.top = '';
    chatWindow.style.height = '';
    chatWindow.style.bottom = '';
    if (_vpListener && window.visualViewport) {
      window.visualViewport.removeEventListener('resize', _vpListener);
      window.visualViewport.removeEventListener('scroll', _vpListener);
      _vpListener = null;
    }
    var _footerEl = chatWindow.querySelector('.wv-footer');
    if (_footerEl) _footerEl.style.paddingBottom = '';
  }

  // Event listeners
  bubble.addEventListener('click', function () { isOpen ? closeChat() : openChat(); });
  document.getElementById('wv-close').addEventListener('click', function (e) { e.stopPropagation(); closeChat(); });
  sendBtn.addEventListener('click', function () { sendMessage(inputEl.value); });

  inputEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(inputEl.value); }
  });

  inputEl.addEventListener('input', function () {
    this.style.height = 'auto';
    this.style.height = Math.min(this.scrollHeight, 80) + 'px';
  });

  // Show badge after 8 seconds
  setTimeout(function () { if (!isOpen) { badge.style.display = 'flex'; } }, 8000);

  // 20-min inactivity reset
  var inactivityTimer = null;
  function resetInactivityTimer() {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(function () {
      localStorage.removeItem(MSG_STORE_KEY);
      localStorage.removeItem('wv_session_id');
      sessionId = getSessionId();
      MSG_STORE_KEY = 'wv_msgs_' + sessionId;
      if (isOpen) {
        messagesEl.innerHTML = '';
        addMessage("Votre session a expiré après 30 min d'inactivité. Je suis toujours là si vous avez des questions 😊", 'bot');
      }
    }, INACTIVITY_MS);
  }

  inputEl.addEventListener('focus', resetInactivityTimer);
  sendBtn.addEventListener('click', resetInactivityTimer);
  bubble.addEventListener('click', resetInactivityTimer);
  resetInactivityTimer();

  // GSAP — hover spring only (video handles its own animation)
  (function () {
    if (window.gsap) { initHover(); return; }
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    s.integrity = 'sha512-7eHRwcbYkK4d9g/6tD/mhkf++eoTHwpNM9woBxtPUBWm67zeAfFC+HrdoE2GanKeocly/VxeLvIqwvCdk7qScg==';
    s.crossOrigin = 'anonymous';
    s.referrerPolicy = 'no-referrer';
    s.onload = initHover;
    document.head.appendChild(s);

    function initHover() {
      bubble.addEventListener('mouseenter', function () {
        gsap.to(bubble, { scale: 1.13, duration: 0.3, ease: 'back.out(2.5)' });
      });
      bubble.addEventListener('mouseleave', function () {
        gsap.to(bubble, { scale: 1, duration: 0.25, ease: 'sine.out' });
      });
    }
  })();

})();
